import {combineReducers} from 'redux'
import session from './sessionReducer'
import content from './contentReducer'
import synthesis from './synthesisReducer'
import data from './dataReducer'

// Telling the rootReducer to
// use the sessionReduce
export let rootReducer = combineReducers({
  session,
  data,
  content,
  synthesis
})



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js